import React, { useState } from 'react';

const Section = ({ title, children, initiallyCollapsed = false, headerMeta = null }) => {
    const [isCollapsed, setIsCollapsed] = useState(initiallyCollapsed);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className="section">
            <div
                className={`section-header ${isCollapsed ? 'collapsed' : ''}`}
                onClick={toggleCollapse}
            >
                <div className="section-header-main">
                    <h2>{title}</h2>
                    {headerMeta ? <div className="section-header-meta">{headerMeta}</div> : null}
                </div>
                <div className="toggle-icon">▼</div>
            </div>
            <div className={`section-content ${isCollapsed ? 'collapsed' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default Section;
